import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    color,
    linkLabel,
    isLoading,
    designVersion,
    designContext
  } = _ref;
  var cornerRadius = designContext.get('alert-banner/corner-radius').value();
  var borderRadius = isLollipop(designVersion) ? 0 : cornerRadius;
  var textColor = designContext.get('alert-banner/text-color').toString();
  var textStyle = designContext.get('alert-banner/text-style');
  return {
    rootStyle: {
      borderRadius,
      backgroundColor: color,
      flexDirection: 'row',
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 15
    },
    iconStyle: {
      paddingRight: 15
    },
    paragraphStyle: {
      flexGrow: 1,
      flexShrink: 1,
      paddingRight: linkLabel || isLoading ? 15 : 0
    },
    paragraphSecondaryBlockStyle: _objectSpread(_objectSpread({
      color: textColor
    }, textStyle.styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: -1,
      paddingBottom: 5,
      paddingTop: 0
    }),
    linkWrapperStyle: {
      flexShrink: 0
    },
    loaderWrapperStyle: {
      flexShrink: 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map